import Icon from "@mui/material/Icon";
import { withStyles } from "@mui/styles";
import { Box, Button } from "@mui/material";
import React, { Component } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import Typography from "@mui/material/Typography";
import classNames from "classnames";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

class SimpleClaimSubmitDialog extends Component {
  dialogType = classes => {
    let type = {
      error: {
        icon: (
          <Icon
            classes={{
              root: classNames(classes.iconError, classes.icon)
            }}
          >
            cancel
          </Icon>
        )
      },
      success: {
        icon: (
          <Icon
            classes={{
              root: classNames(classes.iconiconSuccessError, classes.icon)
            }}
          >
            check_circle
          </Icon>
        )
      }
    };
    return { TYPE: type };
  };

  dialogTitleStyle = type => {
    const { classes } = this.props;
    switch (type) {
      case "error":
        return classes.dialogTitleError;
      case "success":
        return classes.dialogTitleSuccess;
      default:
        return {};
    }
  };

  render() {
    const {
      name,
      title,
      description,
      alignCenter = false,
      isHtml = false,
      open,
      closeHandler,
      closeButtonText,
      classes,
      url = "",
      handleClose,
      showCloseIcon = false
    } = this.props;
    let type = this.props.type || "success";
    const { TYPE } = this.dialogType(classes);

    return (
      <Dialog
        open={open}
        onClose={closeHandler}
        maxWidth="xs"
        aria-labelledby={`${name}-title`}
        aria-describedby={`${name}-description`}
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogContent
          className={classNames(
            classes.dialogContent,
            classes.dialogContentCenter && alignCenter
          )}
        >
          {type !== "none" && url == "" ? (
            <DialogTitle
              classes={{
                root: classNames(
                  classes.dialogTitle,
                  this.dialogTitleStyle(type)
                )
              }}
              disableTypography={true}
              id={`${name}-title`}
            >
              {TYPE[type].icon}
              <div>{title}</div>
            </DialogTitle>
          ) : (
            ""
          )}

          {url?.length ? (
            <DialogTitle
              classes={{
                root: classNames(
                  classes.dialogTitle,
                  classes.dialogTitleSuccess
                )
              }}
              disableTypography={true}
              id={`${name}-title`}
            >
              <div>{title}</div>
            </DialogTitle>
          ) : (
            ""
          )}

          <IconButton
            aria-label="close"
            onClick={handleClose}
            className={classes.claimBtnClose}
            sx={theme => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500]
            })}
          >
            <CloseIcon />
          </IconButton>

          {url?.length ? (
            <DialogContentText
              classes={{
                root: classes.description
              }}
              id={`${name}-description`}
            >
              <p style={{ color: "black" }}>
                If you wish to be better informed about the differences between
                your Corporate Medical Insurance and Personal Insurance, please
                click "Yes".
              </p>
            </DialogContentText>
          ) : (
            ""
          )}
        </DialogContent>
        <DialogActions
          classes={{
            root: classes.dialogActions
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            mt={2}
          >
            <Button
              onClick={() => {
                window.open(
                  " https://forms.office.com/pages/responsepage.aspx?id=XjAHcGQma065pMTVzP0VJFHPBrheQFdAjdM3Z1bqGSdUMkg0MzlOSDFUWkRKWTU4RlE1SFpENjBVUS4u&route=shorturl."
                );
                handleClose();
              }}
              variant="contained"
              color="primary"
              className={classes.dialogActionsButton}
              type="button"
            >
              Yes
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = theme => ({
  dialogPaper: {
    border: "1px solid #ccc",
    borderRadius: 12,
    padding: "24px",
    backgroundColor: "#fff"
  },
  claimBtnClose: {
    border: "2px solid",
    padding: "3px"
  },
  dialogContent: {
    textAlign: "center",
    padding: "0px"
  },
  description: {
    textAlign: "center",
    color: "#666",
    fontSize: "16px",
    marginBottom: "24px"
  },
  dialogActions: {
    justifyContent: "center"
  },
  dialogActionsButton: {
    backgroundColor: "#d32f2f",
    color: "#fff",
    borderRadius: "24px",
    padding: "10px 32px",
    fontSize: "16px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#b71c1c"
    }
  }
});

export default withStyles(styles, { withTheme: true })(SimpleClaimSubmitDialog);
